<template>
  <main class="mt-3">
    <div v-if="isSaving" class="saving-indicator">
      <span class="spinner"></span>
      데이타 저장 중...
    </div>
    
    <div class="p-1 text-center">
      <h2 class="text-center"><u>상품가격등록</u></h2>
      <div class="mb-3 row">
        <!-- 수정불가 -->
        <label class="col-md-3 col-form-label lb_title">상품코드</label>
        <div class="col-md-9">
          <input type="text" class="form-control" v-model="this.productId" readonly>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label lb_title">상품구분</label>
        <div class="col-md-9">
          <div class="form-check-inline" :key=i v-for="(baseCode,i) in this.sRoute">
            <div v-if="this.sRoute[i].baseCode === this.salesRoute">
              <input class="form-check-input" type="radio" v-model="productInfo.salesRoute" value=this.sRoute[i].baseCode ref="rbt_salesRoute" checked disabled>
              <label class="form-check-label text-primary" for="flexRadioDefault2">
                {{ this.sRoute[i].codeNameKor }}
              </label>
            </div>
            <div v-else>
              <input class="form-check-input" type="radio" v-model="productInfo.salesRoute" value=this.sRoute[i].baseCode ref="rbt_salesRoute" disabled>
              <label class="form-check-label text-secondary" for="flexRadioDefault2">
                {{ this.sRoute[i].codeNameKor }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-3 col-form-label lb_title">상품명<font class="text-secondary" style="font-size: small;">(국문)</font></label>
        <div class="col-md-9">
          <input type="text" class="form-control" ref="txt_pdtNameKor" v-model="productInfo.pdtNameKor" disabled>
        </div>
      </div>

      <div style="text-align: left; padding-left: 10%;">
        <button class="btn btn-md btn-outline-primary"  @click="changeDsipDetail" v-if="this.dispDetail === 'N'"> 상품정보 더보기</button>
        <button class="btn btn-md btn-primary"  @click="changeDsipDetail" v-else> 상품정보 더보기</button>
      </div>

      <div class="col-12 pdtDetail" v-if="this.dispDetail == 'Y'">
        <div class="mb-3 row">
          <label class="col-md-3 col-form-label lb_title">상품명<font class="text-secondary" style="font-size: small;">(영문)</font></label>
          <div class="col-md-9">
            <input type="text" class="form-control" v-model="productInfo.pdtNameEng" disabled>
          </div>
        </div>

        <div class="mb-3 row">
          <label class="col-md-3 col-form-label lb_title">국가 / 지역</label>
          <div class="col-md-9">
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="this.productInfo.ntName" disabled>
              <input type="text" class="form-control" v-model="this.productInfo.arName" disabled>
            </div>
          </div>
        </div>

        <div class="mt-3 mb-3 row">
          <label class="col-md-3 col-form-label lb_title">여행/유효기간</label>
          <div class="col-md-9">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">개시</span>
              <input type="date" class="form-control" ref="txt_salesStart" v-model="productInfo.tripStart" disabled>
              <span class="input-group-text" id="basic-addon1">종료</span>
              <input type="date" class="form-control" v-model="productInfo.tripEnd" disabled>
            </div>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-3 col-form-label lb_title">판매기간</label>
          <div class="col-md-9">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">개시</span>
              <input type="date" class="form-control" ref="txt_salesStart" v-model="productInfo.salesStart" disabled>
              <span class="input-group-text" id="basic-addon1">종료</span>
              <input type="date" class="form-control" ref="txt_salesStart" v-model="productInfo.salesEnd" disabled>
            </div>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-3 col-form-label lb_title">특기사항</label>
          <div class="col-md-9">
            <textarea class="form-control" placeholder="200자 이내" ref="txt_nContent" id="floatingTextarea" style="height:80px" 
              v-model="productInfo.pdtRemarks" maxlength="210" disabled></textarea>
          </div>
        </div>
      </div>

      <!-- 연계할인율 -->
      <hr class="mt-3 mb-3" style="border: solid 2px;" v-if="this.productInfo.assoFlag != null && this.productInfo.assoFlag != undefined && this.productInfo.assoFlag != ''">

      <div id="priceSet" class="mt-3 mb-3 row" v-if="this.productInfo.assoFlag != null && this.productInfo.assoFlag != undefined && this.productInfo.assoFlag != ''">
        <div class="col-md-3">
          <label class="lb_title">
            연계할인율 설정
          </label>
        </div>

        <div class="col-md-9" style="text-align: center;">
          <table class="tb_pdtPrice col-12">
            <tr>
              <th class="reqMark" style="width:200px;">할인율 (%)</th>
              <td>
                <div class="input-group" style="width: 180px;">
                  <input type="number" class="form-control text-end" style="width: 100px;" ref="asso_DCRate" v-model="this.productInfo.asso_DCRate">
                  <button class="btn btn-sm btn-success" @click="change_assoDCRate(this.productInfo.asso_DCRate)">변경</button>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <hr class="mt-3 mb-3" style="border: solid 2px;">

      <!-- 가격설정 -->
      <div id="priceSet" class="mt-5 mb-3 row">
        <div class="col-md-3">
          <label class="lb_title">
            가격설정
            <p style="font-size: 0.8rem; font-weight: normal; color: gray;">
              ※ 할인기간은 구매일자가 기준입니다.
            </p>
            <!-- <button class="btn btn-sm" @click="showDC()" :class="showDC_flag == 'N' ? 'btn-outline-primary' : 'btn-primary'">즉시할인설정</button> -->
          </label>
          <div>
            <button class="btn btn-sm btn-outline-primary" @click="showDC" v-if="this.showDC_flag === 'N'">즉시할인설정</button>
            <button class="btn btn-sm btn-primary" @click="showDC" v-else-if="this.showDC_flag === 'Y'">즉시할인취소</button>
          </div>
        </div>

        <div class="col-md-9" style="text-align: center;">
          <table class="tb_pdtPrice col-12">
            <tr>
              <th class="reqMark" style="width:200px;"><span class="text-danger fs-4">*</span> 판매가 <span class="text-secondary fw-normal">(10원미만 절사)</span></th>
              <td>
                <input type="number" class="form-control" style="width: 300px; font-size: small;" ref="basicPrice" v-model="basicPrice">
              </td>
              <th class="reqMark" style="width:200px;">판매기간 <span class="text-secondary fw-normal">(미설정: 무기한)</span></th>
              <td>
                <div class="input-group">
                  <span class="input-group-text" style="font-size: small;">개시</span>
                  <input type="date" class="form-control" ref="txt_pdtPriceStart" style="font-size: small;" v-model="bsPriceStart">
                  <span class="input-group-text" style="font-size: small;">종료</span>
                  <input type="date" class="form-control" ref="txt_pdtPriceEnd" style="font-size: small;" v-model="bsPriceEnd">
                </div>
              </td>
            </tr>

            <tr>
              <th class="reqMark" style="width:200px;" v-if="this.showDC_flag === 'Y'">즉시할인 <span class="text-secondary fw-normal">(100%할인불가)</span></th>
              <td v-if="this.showDC_flag === 'Y'">
                <div class="input-group" style="width: 300px;">
                  <input type="number" class="form-control input-group" style="width:200px; font-size: small;" ref="dcPrice" v-model="dcPrice">
                  <select class="input-group form-control-sm" style="width:100px;font-size: small;" v-model="dcMethod">
                    <option value="A" id="paymentMethod">원</option>
                    <option value="P" id="paymentMethod">%</option>
                  </select>
                </div>
              </td>
              <th class="reqMark" style="width:200px;" v-if="this.showDC_flag === 'Y'">할인기간 <span class="text-secondary fw-normal">(미설정: 무기한)</span></th>
              <td v-if="this.showDC_flag === 'Y'">
                <div class="input-group">
                  <span class="input-group-text" style="font-size: small;">개시</span>
                  <input type="date" class="form-control" ref="dcPriceStart" style="font-size: small;" v-model="dcPriceStart">
                  <span class="input-group-text" style="font-size: small;">종료</span>
                  <input type="date" class="form-control" ref="txt_pdtPriceEnd" style="font-size: small;" v-model="dcPriceEnd">
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 옵션설정 -->
      <div id="priceSet" class="mt-5 mb-3 row">
        <div class="col-md-3 col-form-label">
          <label class="lb_title">
            옵션설정
          </label>
          <div>
            <button class="btn btn-sm btn-outline-primary" @click="showSellOptType()" v-if="this.showSellOptType_flag === 'N'">선택형설정</button>
            <button class="btn btn-sm btn-primary" @click="showSellOptType()" v-else>선택형취소</button>
            <br>
            <br>
            <button class="btn btn-sm btn-outline-success" @click="showDirOptType()" v-if="this.showDirOptType_flag === 'N'">직접형설정</button>
            <button class="btn btn-sm btn-success" @click="showDirOptType()" v-else>직접형취소</button>
          </div>
        </div>


        <div class="col-md-9" v-if="showSellOptType_flag == 'Y'">
          <table class="tb_pdtPrice col-12">
            <tr>
              <th style="width: 200px;">엑셀업로드</th>
              <td colspan="3">
                <!-- flex 컨테이너로 직접 구현 -->
                <div style="display: flex; align-items: center; gap: 16px;">
                  <label class="btn btn-outline-secondary btn-sm mb-0" style="margin-bottom: 0;">
                    <input type="file" ref="searchExcel" @change="onFileSelected" accept=".xlsx, .xls, .csv" />
                  </label>
                  <span style="display: inline-flex; align-items: right; color: red;">
                    날짜형 옵션&nbsp;
                  </span>
                  <span style="display: inline-flex; align-items: left;">
                    <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="dType" ref="dType" @change="checkdType(dType)">
                  </span>
                  <span style="display: inline-flex; align-items: right;">
                    <input type="number" class="form-control" style="width: 100px; font-size: small;" ref="osYear" v-model="osYear" placeholder="적용연도">
                  </span>
                  &nbsp;※ 엑셀 '적용연도' 컬럼에 값이 있으면 그 값을 그대로 적용합니다. 공란이면 위 기본연도가 적용됩니다.
                  <button class="btn btn-sm btn-outline-success ms-auto" @click="downloadSelOptExcel" v-if="this.tableData.length>0">
                    <i class="bi bi-download"></i>&nbsp;엑셀다운로드
                  </button>
                </div>
              </td>
            </tr>
          </table>

          <!-- 선택형옵션 데이타 업로드 후 -->
          <div class="col-12 mt-4" style="display: flex; justify-content: space-between;" v-if="this.tableData.length>0">
            <div style="width: 30%; text-align: left;">
              <button class="btn btn-sm btn-danger" @click="del_checkedOpt('opt')">선택삭제</button>&nbsp;&nbsp;
              <button class="btn btn-sm btn-info" @click="upd_checkedOpt('opt')">선택변경(옵션가/재고/사용어부)</button>
            </div>
            <div class="input-group input-group-sm" style="width: 70%; padding-right: 0;">
              <span class="input-group-text" style="font-size: small; flex: 0 0 80px; text-align: center;">옵션가격</span>
              <input type="text" class="form-control" ref="optPrice_sel" style="font-size: small; flex: 0 0 120px; max-width: 120px;" v-model="optPrice_sel">

              <span class="input-group-text" style="font-size: small; flex: 0 0 80px; text-align: center;">재고수량</span>
              <input type="text" class="form-control" ref="qty_sel" style="font-size: small; flex: 0 0 120px; max-width: 120px;" v-model="qty_sel">

              <span class="input-group-text" style="font-size: small; flex: 0 0 80px; text-align: center;">사용여부</span>
              <select class="input-group form-control-sm" style="width:100px;font-size: small;" v-model="useFlag_sel">
                <option value="Y" id="paymentMethod">Y</option>
                <option value="N" id="paymentMethod">N</option>
              </select>
              <button class="btn btn-sm btn-dark" @click="updateOptionValue('opt')">선택목록적용</button>
            </div>
          </div>

          <div class="table-scroll-box mt-2">
            <table v-if="tableData.length" class="table table-bordered mt-1">
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" v-model="allSelected" @change="toggleAll('opt')" />
                  </th>
                  <th v-for="(header, idx) in tableHeaders" :key="idx">
                    {{ header }}
                  </th>
                  <!-- (추가) 날짜형 옵션인 경우, 행별 적용연도 표시/수정 -->
                  <th v-if="dType === 'Y'" style="width:100px;">적용연도</th>
                  <th>삭제</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in tableData" :key="idx">
                  <td>
                    <input type="checkbox" class="form-check-input" :value="row.osSeq" v-model="selectedRows"/>
                    <input type="hidden" class="form-control form-control-sm" v-model="row.osSeq" disabled>
                  </td>
                  <td v-for="(header, cellIdx) in tableHeaders" :key="cellIdx">
                    <input type="text" class="form-control form-control-sm" v-model="row[header]">
                  </td>
                  <!-- (추가) tableDataForDB[idx]를 직접 바인딩 — 실제 저장은 tableDataForDB 기준이므로 -->
                  <td v-if="dType === 'Y'">
                    <input type="text" class="form-control form-control-sm" v-model="tableDataForDB[idx].appliedYear" placeholder="공란시 기본연도">
                  </td>
                  <td>
                    <button class="btn btn-sm btn-outline-danger" @click="del_selOptRow('opt', idx)">
                      <i class="bi bi-x-lg fw-bolder" style="font-size: 0.8rem;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div v-else></div>
      </div>


      <!-- 직접형 옵션설정 -->
      <div id="priceSet" class="mt-0 mb-5 row">
        <div class="col-md-3 col-form-label"></div>
        <div class="col-md-9" v-if="showDirOptType_flag === 'Y'">
          <table class="tb_pdtPrice col-12">
            <tr>
              <th style="width: 200px;">옵션명 갯수</th>
              <td colspan="3">
                <div style="display: flex; align-items: center; gap: 16px;">
                  <select class="input-group form-control-sm" style="width:100px;font-size: small;" v-model="dirOptCount">
                    <option v-for="n in 5" :key="n" :value="n">{{ n }}개</option>
                  </select>
                  <button class="btn btn-sm btn-outline-success ms-auto" @click="downloadDirOptExcel" v-if="this.dirOptList.length>0">
                    <i class="bi bi-download"></i>&nbsp;엑셀다운로드
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th :rowspan=dirOptCount+1 style="width: 200px;">옵션목록</th>
              <th style="width: 58%">옵션명</th>
              <th style="width: 14%">사용여부</th>
              <th style="width: 12%"></th>
            </tr>
            <tr v-for="(opt, idx) in dirOptList" :key="idx">
              <td style="width: 58%">
                <input type="text" class="form-control" style="font-size: small;" placeholder="25자까지" maxlength="25" v-model="opt.odName">
              </td>
              <td style="width: 14%;">
                <div style="justify-content: center;">
                  <select class="form-control-sm" style="width:200px;font-size: small;" v-model="opt.odUseFlag">
                    <option value="Y">Y</option>
                    <option value="N">N</option>
                  </select>
                </div>
              </td>
              <td style="width: 12%">
                <button class="btn btn-sm btn-outline-danger" @click="del_dirOpt(idx)" :disabled="dirOptList.length === 1">
                  <i class="bi bi-x fw-bolder" style="font-size: 1.0rem"></i>
                </button>
                &nbsp;&nbsp;
                <button class="btn btn-sm btn-outline-primary" @click="add_dirOpt" :disabled="dirOptList.length >= 5">
                  <i class="bi bi-plus fw-bolder" style="font-size: 1.0rem"></i>
                </button>
              </td>
            </tr>
          </table>
          <div class="mt-2 text-start" v-if="dirOptList.length > 0">
            <button class="btn btn-sm btn-info" @click="changeOpt_dir(dirOptList[0].odCode)">직접형옵션 변경</button>
          </div>          
        </div>
        <div v-else></div>
      </div>

      <hr>


      <!-- ----------------추가상품설정------------------------- -->
      <!-- 티켓패스와 연계상품의 경우, 추가상품 설정 불가 <= 에러원인 규명 후 설정가능하게 수정예정 -->
      <div id="priceSet" class="mt-5 mb-5 row" v-if="this.productInfo.salesRoute !== 'E' && (this.productInfo.assoFlag == '' || this.productInfo.assoFlag == null)">
        <div class="col-md-3 col-form-label">
          <label class="lb_title">
            추가상품설정
          </label>
          <div>
            <button class="btn btn-sm btn-outline-warning" @click="showAddPdtType()" v-if="this.showAddPdtType_flag === 'N'">상품설정</button>
            <button class="btn btn-sm btn-warning" @click="showAddPdtType()" v-else>설정취소</button>
            <!-- <br>
            <br>
            <button class="btn btn-sm btn-outline-success" @click="showDirOptType()" v-if="this.showDirOptType_flag === 'N'">직접형설정</button>
            <button class="btn btn-sm btn-success" @click="showDirOptType()" v-else>직접형취소</button> -->
          </div>
        </div>


        <div class="col-md-9" v-if="showAddPdtType_flag == 'Y'">
          <table class="tb_pdtPrice col-12">
            <tr>
              <th style="width: 200px; background-color: rgb(245, 229, 208);">추가상품엑셀업로드</th>
              <td colspan="3">
                <!-- flex 컨테이너로 직접 구현 -->
                <div style="display: flex; align-items: center; gap: 16px;">
                  <label class="btn btn-outline-secondary btn-sm mb-0" style="margin-bottom: 0;">
                    <input type="file" ref="searchExcel" @change="onFileSelected_add" accept=".xlsx, .xls, .csv" />
                  </label>
                  <!-- 네이버데이타 구조상 날짜형은 불가 -->
                  <!-- <span style="display: inline-flex; align-items: right; color: red;">
                    날짜형 옵션&nbsp;
                  </span>
                  <span style="display: inline-flex; align-items: left;">
                    <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="add_dType" ref="dType" @change="checkAdd_dType(add_dType)">
                  </span>
                  <span style="display: inline-flex; align-items: right;">
                    <input type="number" class="form-control" style="width: 100px; font-size: small;" ref="addPdtYear" v-model="addPdtYear" placeholder="적용연도">
                  </span> -->
                  <button class="btn btn-sm btn-outline-success ms-auto" @click="downloadAddPdtExcel" v-if="this.tableData_add.length>0">
                    <i class="bi bi-download"></i>&nbsp;엑셀다운로드
                  </button>
                </div>
              </td>
            </tr>
          </table>

          <!-- 추가상품 데이타 업로드 후 -->
          <div class="col-12 mt-4" style="display: flex; justify-content: space-between;" v-if="this.tableData_add.length>0">
            <div style="width: 30%; text-align: left;">
              <button class="btn btn-sm btn-success" @click="del_checkedOpt('add')">선택삭제</button>&nbsp;&nbsp;
              <button class="btn btn-sm btn-warning" @click="upd_checkedOpt('add')">선택변경(추가상품가/재고/사용어부)</button>
            </div>
            <div class="input-group input-group-sm" style="width: 70%; padding-right: 0;">
              <span class="input-group-text" style="font-size: small; flex: 0 0 80px; text-align: center;">추가상품가</span>
              <input type="text" class="form-control" ref="optPrice_sel" style="font-size: small; flex: 0 0 120px; max-width: 120px;" v-model="optPrice_sel_add">

              <span class="input-group-text" style="font-size: small; flex: 0 0 80px; text-align: center;">재고수량</span>
              <input type="text" class="form-control" ref="qty_sel" style="font-size: small; flex: 0 0 120px; max-width: 120px;" v-model="qty_sel_add">

              <span class="input-group-text" style="font-size: small; flex: 0 0 80px; text-align: center;">사용여부</span>
              <select class="input-group form-control-sm" style="width:100px;font-size: small;" v-model="useFlag_sel_add">
                <option value="Y" id="paymentMethod">Y</option>
                <option value="N" id="paymentMethod">N</option>
              </select>
              <button class="btn btn-sm btn-dark" @click="updateOptionValue('add')">선택목록적용</button>
            </div>
          </div>

          <div class="table-scroll-box mt-2">
            <table v-if="tableData_add.length" class="table table-bordered mt-1">
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" v-model="allSelected_add" @change="toggleAll('add')" />
                  </th>
                  <!-- 동적 헤더 생성 -->
                  <th v-for="(header, idx) in tableHeaders_add" :key="idx">
                    {{ header }}
                  </th>
                  <th>삭제</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in tableData_add" :key="idx">
                  <td>
                    <input type="checkbox" :value="idx" v-model="selectedRows_add"/>
                  </td>
                  <!-- 동적 데이터 셀 -->
                  <td v-for="(header, cellIdx) in tableHeaders_add" :key="cellIdx">
                    <input type="text" class="form-control form-control-sm" v-model="row[header]">
                  </td>
                  <td>
                    <button class="btn btn-sm btn-outline-danger" @click="del_selOptRow('add', idx)">
                      <i class="bi bi-x-lg fw-bolder" style="font-size: 0.8rem;"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div v-else></div>
      </div>

      <hr>

      <div class="mt-5 mb-3 row">
        <label class="col-sm-3 col-form-label lb_title">결제방법<span class="text-danger">*</span></label>
        <div class="col-sm-9">
          <table class="table table-bordered border-success align-middle">
            <tr>
              <th style="font-size: 1rem;">
                1차 결제 <span class="text-danger">(잔여액은 2차 결제액으로 설정됩니다. 100%로 입력하면 전액결제로 처리됩니다)</span>
              </th>
              <!-- <td class="text-center text-sm">
                2차 결제(잔액)
              </td> -->
            </tr>
            <tr>
              <td>
                <div v-if="!productInfo.salesRoute">
                </div>
                <div class="input-group mt-1">
                  <input type="number" class="form-control text-end" min="0" ref="firstPayment" style="width:70%;" v-model="productInfo.firstPayment">
                  <select class="form-select form-select-md" aria-label=".form-select-md" style="width:30%;" v-model="productInfo.paymentMethod">
                    <option value="P" id="paymentMethod">%</option>
                    <!-- <option value="A" id="paymentMethod">원</option> -->
                  </select>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>


      <div class="mb-3 row">
        <div class="col-3"></div>
        <div class="col-9">
          <button type="button" class="btn btn-lg btn-outline-primary" style="width:40%" @click="priceInsert_new();">저장</button>&nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-lg btn-outline-danger"  style="width:40%" @click="goToList()">취소</button>&nbsp;&nbsp;&nbsp;
          <!-- <button type="button" class="btn btn-lg btn-outline-success"  style="width:40%" @click="goToCheckPage(this.productId, this.productId.charAt(0) )">검증</button> -->
        </div>
      </div>

    </div>
  </main>
</template>

<script>
//import {genCode} from '../assets/js/genCode'
import * as XLSX from 'xlsx'
import dayjs from "dayjs"
import optionTableMixin from '../assets/js/Optiontablemixin.js'

export default {
  mixins: [optionTableMixin],
  data() { 
    return {
      isSaving: false,              // 저장중 여부

      priceAri: "N",                // 가격정보가 존재하는지 여부

      productInfo: {},              //상품기본정보
      product_prc_info: [],         //상품가격정보
      product_opt_sel_info: [],     //선택형옵션정보-마스터
      product_opt_sel_info_d: [],   //선택형옵션정보-디테일
      product_addpdt_m_info: [],    //추가상품정보-마스터
      product_addpdt_d_info: [],    //추가상품정보-디테일

      // 표시처리
      dispDetail: "N",              //상품상세정보 표시여부
      showDC_flag: "N",             //즉시할인 표시여부
      showSellOptType_flag: "N",    //선택형옵션 표시여부
      showDirOptType_flag: "N",     //직접입력옵션 표시여부
      showAddPdtType_flag: "N",     //추가상품 표시여부

      // 판매가 기본정보
      basicPrice: 0,                //판매가
      dcPrice: 0,                   //즉시할인액
      dcMethod: "",                 //즉시할인방법(원/퍼센트)
      bsPriceStart: null,           //기본가격적용시작일
      bsPriceEnd: null,             //기본가격적용종료일
      dcPriceStart: null,           //할인가격적용시작일
      dcPriceEnd: null,             //할인가격적용종료일
      // option_sel_flag: "N",         //선택형옵션여부(YN)

      // options_dir_flag: "N",        //직입력옵션여부(YN)

      dType: "Y",                   //날짜형 옵션 여부
      osYear: dayjs().year(),       //옵션적용연도(기본값 - 행별 적용연도가 공란일 때 사용)

      add_dType: "N",               //추가상품 날짜형 옵션 여부
      addPdtYear: dayjs().year(),   //추가상품적용연도

      prcCode: "",                  //가격코드

      // 선택옵션 업로드
      nullHeaderCount: 0,           // 더미선택형옵션헤더
      uploadedNullHeaderCount: 0,   // 업로드된 더미선택형옵션헤더
      file: null,
      fileName: '',
      tableHeaders: [],
      tableHeadersForDB: [],        // DB에 저장할 헤더(더미헤더 발생 시)
      tableData: [],
      tableDataForDB: [],
      selectedRows: [],
      allSelected: false,

      //// 업데이트할 데이타이므로 ''이면 변경없음
      optPrice_sel: "",              //선택형옵션가격
      qty_sel: "",                   //선택형옵션수량
      useFlag_sel: "",               //선택형옵션사용여부 

      //// 직접형 옵션목록 동적생성
      product_opt_dir_info: [],      // 직접입력옵션정보
      dirOptCount: 1,
      // dirOptList: [{ name: '', useFlag: 'Y' }],
      dirOptList: [{ odName: '', odUseFlag: 'Y' }],

      // 추가상품 업로드
      nullHeaderCount_add: 0,           // 더미선택형옵션헤더
      uploadedNullHeaderCount_add: 0,   // 업로드된 더미선택형옵션헤더
      file_add: null,
      fileName_add: '',
      tableHeaders_add: [],
      tableHeadersForDB_add: [],        // DB에 저장할 헤더(더미헤더 발생 시)
      tableData_add: [],
      tableDataForDB_add: [],
      selectedRows_add: [],
      allSelected_add: false,

      //// 업데이트할 데이타이므로 ''이면 변경없음
      optPrice_sel_add: "",            //추가상품가
      qty_sel_add: "",                 //추가상품재고
      useFlag_sel_add: "",             //추가상품사용여부

      
      sRoute: {},                   //상품구분
    };
  },
    // 로그인된 사용자만 접근가능페이지
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {
    dirOptCount(newVal) {
      const count = parseInt(newVal, 10);
      if (this.dirOptList.length < count) 
      {
        for (let i = this.dirOptList.length; i < count; i++) 
        {
          this.dirOptList.push({ odName: '', odUseFlag: 'Y' });
        }
      } 
      else if (this.dirOptList.length > count) 
      {
        this.dirOptList.splice(count);
      }
    }    
  },
  // 생성 시, 상품카테고리 가져온다
  created() {
    this.productId = this.$route.query.productId;
    this.salesRoute = this.$route.query.salesRoute;

    this.getProductInfo();
    this.getSalesRoute();
  },
  mounted() {
    //console.log("handler:",this.user.handlerId);

    // 로그인한 사람이 아니라면 메인화면으로
    if(!this.user.handlerId || this.user.handlerGrade > 9) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '',
        text: '로그인 권한이 없습니다.',
        icon: 'error'
      });
      this.$router.push({path: '/b2bLogin'});
    }

    //document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";    
  },
  methods: {

    //로딩인디케이터
    showLoading() {
      this.$loading.start()
      setTimeout(() => {
        this.$loading.finish()
      }, 3000)
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    getDayOfWeekFormat(text) {
      return this.$dayOfWeekFormat(text);
    },
    getNumberOfWeekFormat(text) {
      return this.$numberOfWeekFormat(text);
    },
    async getNationList() {
      let nationList_via = await this.$api("/api/nationList", {});
      this.nationList_via = nationList_via;
      //console.log("nationList_via",nationList_via);
    },
    async getSalesRoute() {
      this.sRoute = await this.$api("/api/salesRoute", {});
      //console.log("sRoute",this.sRoute);
    },

    changeDsipDetail() {
      this.dispDetail = this.dispDetail === 'N' ? 'Y' : 'N';
    },

  //연계상품 할인율 변경
  async change_assoDCRate(dRate) {
    if(dRate*1 > 100 || dRate < 0) 
    {
      this.$swal.fire("","할인율은 100%를 초과하거나 마이너스할인일 수 없습니다", "warning")
      return false
    }
    else 
    {
      let res_changeAssoDCRate = await this.$api("/api/changeAssoDCRate", {param: [ dRate, this.productId]});
      if(res_changeAssoDCRate.affectedRows < 1) 
      {
        this.$swal.fire("","변경처리 중 오류가 발생했습니다<br>할인율을 체크한 후 재시도해 주세요", "error")
        return false
      }
      else 
      {
        this.$swal.fire("","할인율이 변경되었습니다. 변경된 할인율은 즉시 적용됩니다.", "success")
      }
    }
  },

    async getProductInfo() {
      let productInfo = await this.$api("/api/pdtInfo", {param: [this.productId]});

      if(productInfo.length > 0)
      {
        this.productInfo = productInfo[0]
        this.productInfo.tripStart = this.getDateFormat(this.productInfo.tripStart);
        this.productInfo.tripEnd = this.getDateFormat(this.productInfo.tripEnd);
        this.productInfo.salesStart = this.getDateFormat(this.productInfo.salesStart);
        this.productInfo.salesEnd = this.getDateFormat(this.productInfo.salesEnd);

        this.getProdut_prc_info(this.productId)
      }
      //console.log("productInfo",this.productInfo);

    },

    // 상품가격정보 취득
    async getProdut_prc_info(pCode) { 
      let product_prc_info = await this.$api("/api/product_prc_info", {param: [pCode]});
      //console.log("product_prc_info:<<<<< ", product_prc_info) 

      let prcCode = ""
      if(product_prc_info.length > 0) 
      {
        this.priceAri = "Y"; // 가격정보가 존재하는지 여부

        prcCode               = product_prc_info[0].prcCode;                          // 가격코드
        this.product_prc_info = product_prc_info[0];
        this.showDC_flag      = product_prc_info[0].dcFlag;                           // 즉시할인 표시여부

        this.basicPrice   = product_prc_info[0].pdtPrice;                             // 판매가
        this.bsPriceStart = product_prc_info[0].pdtPriceStart == undefined ? null : this.getDateFormat(product_prc_info[0].pdtPriceStart);    // 판매가적용시작일
        this.bsPriceEnd   = product_prc_info[0].pdtPriceEnd   == undefined ? null : this.getDateFormat(product_prc_info[0].pdtPriceEnd);      // 판매가적용종료일
        
        this.dcPrice      = product_prc_info[0].dcPrice;                              // 즉시할인액
        this.dcMethod     = product_prc_info[0].dcMethod;                             // 즉시할인방법
        this.dcPriceStart = product_prc_info[0].dcPriceStart == undefined ? null : this.getDateFormat(product_prc_info[0].dcPriceStart);     // 즉시할인적용시작일
        this.dcPriceEnd   = product_prc_info[0].dcPriceEnd   == undefined ? null : this.getDateFormat(product_prc_info[0].dcPriceEnd);       // 즉시할인적용종료일 

        this.showSellOptType_flag = (product_prc_info[0].option_sel_flag == null || product_prc_info[0].option_sel_flag == "") ? "N" : product_prc_info[0].option_sel_flag ; // 선택형옵션 표시여부
        this.showDirOptType_flag  = (product_prc_info[0].option_dir_flag == null || product_prc_info[0].option_dir_flag == "") ? "N" : product_prc_info[0].option_dir_flag ; // 직접입력옵션 표시여부
        this.showAddPdtType_flag  = (product_prc_info[0].addProduct_flag == null || product_prc_info[0].addProduct_flag == "") ? "N" : product_prc_info[0].addProduct_flag ; // 추가상품 표시여부        
        //console.log("OptFlags:::::",this.showSellOptType_flag, this.showDirOptType_flag, "this.showAddPdtType_flag:", this.showAddPdtType_flag)

        // 옵션여부에 따른 옵션정보취득
        if(this.showSellOptType_flag === "Y") 
        {
          let product_opt_sel_info = await this.$api("/api/product_opt_sel_info", {param: [prcCode]});
          //console.log("product_opt_sel_info:****** ", product_opt_sel_info)

          if(product_opt_sel_info.length > 0) 
          {
            this.product_opt_sel_info = product_opt_sel_info[0];
            this.dType = product_opt_sel_info[0].dTypeFlag; // 날짜형 옵션 여부

            this.nullHeaderCount = product_opt_sel_info[0].nullHDCount               //선택옵션 저장 시 사용될 더미헤더 갯수

            //console.log("product_opt_sel_info: ", this.product_opt_sel_info)

            let osCode = product_opt_sel_info[0].osCode;
            //console.log("osCode:>>>> ", osCode)

            let product_opt_sel_info_d = await this.$api("/api/product_opt_sel_info_d", {param: [osCode]});
            //console.log("product_opt_sel_info_d>>>> ", product_opt_sel_info_d)
            
            // (수정) nullHDCount 삼중분기 → optionTableMixin 메서드로 통합
            // 화면표시 라벨은 기존 관행(A안) 그대로 보존, DB저장용은 항상 고정 7컬럼으로 안전하게 구성
            const optNames = {
              name1: product_opt_sel_info[0].osName1,
              name2: product_opt_sel_info[0].osName2,
              name3: product_opt_sel_info[0].osName3,
            };
            const optSrcFields = { name1: 'os1', name2: 'os2', name3: 'os3', price: 'osPrice', qty: 'osQty', maCode: 'osMaCode', status: 'sellStatus' };

            this.tableHeaders = this.buildOptHeaderLabels(optNames, this.product_opt_sel_info.nullHDCount, '옵션가');
            if(!this.tableHeaders) {
              this.$swal.fire("","※ 선택형옵션헤더 설정이 잘못되었습니다. 관리자에게 문의해주세요.", "warning");
              this.showSellOptType_flag = "N";
            }
            else 
            {
              // (수정) DB의 osYear 컬럼을 appliedYear로 매핑 → 기존 데이터를 재저장할 때도 원래 연도가 유지되도록 함
              this.tableData = product_opt_sel_info_d.map(item =>
                this.buildOptRowObject(item, this.tableHeaders, this.product_opt_sel_info.nullHDCount, optSrcFields, {
                  osSeq: item.osSeq,
                  appliedYear: item.osYear != undefined ? String(item.osYear) : ''
                })
              );
            }

            // DB저장용 데이타는 nullHDCount와 무관하게 항상 고정 7컬럼 구조로 구성
            // (버그수정) 기존엔 화면용 this.tableHeaders(짧아진 배열)를 그대로 재사용해서
            // nullHDCount>=1일 때 인덱스가 배열범위를 벗어나 undefined 키로 저장되던 문제가 있었음
            this.tableHeadersForDB = this.buildFullHeaderLabels(optNames, '옵션가');
            // (수정) 여기도 osYear → appliedYear 매핑 추가
            this.tableDataForDB = product_opt_sel_info_d.map(item =>
              this.buildOptRowObject(item, this.tableHeadersForDB, 0, optSrcFields, {
                appliedYear: item.osYear != undefined ? String(item.osYear) : ''
              })
            );
          }
          // 선택옵션이 있다는 플래그가 있어도 실제로 데이타가 없으면 N처리
          else 
          {
            this.showSellOptType_flag = "N"
          }
        }

        //console.log("tableData:>>>> ", this.tableData)

        if(this.showDirOptType_flag === "Y") 
        {
          let product_opt_dir_info = await this.$api("/api/product_opt_dir_info", {param: [prcCode, this.productId]});
          //console.log("product_opt_dir_info:+++++++++++++ ", product_opt_dir_info)
          
          if(product_opt_dir_info.length > 0) 
          {
            let odCode = product_opt_dir_info[0].odCode; // 직접입력옵션코드
            this.product_opt_dir_info = product_opt_dir_info[0]; // 직접입력옵션정보

            let dirOptList = await this.$api("/api/product_opt_dir_info_d", {param: [odCode]});

            if(this.dirOptList.length > 0) 
            {
              this.dirOptList = dirOptList
              // this.dirOptList = product_opt_dir_info.map(item => {
              //   return { name: item.osName, useFlag: item.osUse };
              // });
              this.dirOptCount = this.dirOptList.length;
            }
            //console.log("dirOptList:>>>> ", this.dirOptList)
          }
          else 
          {
            this.showDirOptType_flag = "N"; // 직접입력옵션이 없으면 N처리
          }
        }

        // 추가상품 유무에 따른 상품정보 취득
        if(this.showAddPdtType_flag === "Y") 
        {
          let product_addpdt_m_info = await this.$api("/api/product_addpdt_m_info", {param: [prcCode]});
          //console.log("product_addpdt_m_info:****** ", product_addpdt_m_info)

          if(product_addpdt_m_info.length > 0) 
          {
            this.product_addpdt_m_info = product_addpdt_m_info[0];
            //this.add_dType = product_addpdt_m_info[0].dTypeFlag; // 날짜형 옵션 여부

            //console.log("product_addpdt_m_info: ", this.product_addpdt_m_info)

            let addCode = product_addpdt_m_info[0].addCode;
            // console.log("adCode:>>>> ", addCode)

            let product_addpdt_d_info = await this.$api("/api/product_addpdt_d_info", {param: [addCode]});
            //console.log("product_addpdt_d_info;;;;;;;;; ", product_addpdt_d_info)

            this.nullHeaderCount_add = product_addpdt_m_info[0].add_nullHDCount               //추가상품 저장 시 사용될 더미헤더 갯수
            
            // (수정) add_nullHDCount 삼중분기 → optionTableMixin 메서드로 통합
            // 화면표시 라벨은 기존 관행(A안) 그대로 보존, DB저장용은 항상 고정 7컬럼으로 안전하게 구성
            const addNames = {
              name1: product_addpdt_m_info[0].addName1,
              name2: product_addpdt_m_info[0].addName2,
              name3: product_addpdt_m_info[0].addName3,
            };
            const addSrcFields = { name1: 'add1', name2: 'add2', name3: 'add3', price: 'addPrice', qty: 'addQty', maCode: 'addMaCode', status: 'addStatus' };

            this.tableHeaders_add = this.buildOptHeaderLabels(addNames, this.product_addpdt_m_info.add_nullHDCount, '추가상품가', true);
            if(!this.tableHeaders_add) {
              this.$swal.fire("","※ 추가상품헤더 설정이 잘못되었습니다. 관리자에게 문의해주세요.", "warning");
              this.showAddPdtType_flag = "N";
            }
            else 
            {
              this.tableData_add = product_addpdt_d_info.map(item =>
                this.buildOptRowObject(item, this.tableHeaders_add, this.product_addpdt_m_info.add_nullHDCount, addSrcFields, {}, true)
              );
            }

            // DB저장용 데이타는 add_nullHDCount와 무관하게 항상 고정 7컬럼 구조로 구성
            // (버그수정) 기존엔 화면용 this.tableHeaders_add(짧아진 배열)를 그대로 재사용해서
            // add_nullHDCount>=1일 때 인덱스가 배열범위를 벗어나 undefined 키로 저장되던 문제가 있었음
            // (2026-07-10 재수정) swapStatusMaCode=true: 추가상품 실제 엑셀 원본 순서가
            // [...,사용여부,관리코드]로 옵션(opt)과 반대라, 엑셀업로드 경로(onFileSelected_add)와
            // 순서를 일치시켜야 priceInsert_new의 고정 인덱스 읽기가 두 경로 모두 정확해진다.
            this.tableHeadersForDB_add = this.buildFullHeaderLabels(addNames, '추가상품가', true);
            this.tableDataForDB_add = product_addpdt_d_info.map(item =>
              this.buildOptRowObject(item, this.tableHeadersForDB_add, 0, addSrcFields, {}, true)
            );
          }
          // 선택옵션이 있다는 플래그가 있어도 실제로 데이타가 없으면 N처리
          else 
          {
            this.showSellOptType_flag = "N"
          }
        }        
      }
    },

    //즉시할인 표시처리 & 초기화
    showDC() {
      this.showDC_flag = this.showDC_flag === "N" ? "Y" : "N";

      if(this.showDC_flag === "N") 
      {
        this.dcPrice = this.product_prc_info.dcPrice != undefined ? this.product_prc_info.dcPrice : 0;                                        // 즉시할인액 초기화
        this.dcMethod = this.product_prc_info.dcMethod != undefined ? this.product_prc_info.dcMethod : "";                                    // 즉시할인방법 초기화
        this.dcPriceStart = this.product_prc_info.dcPriceStart != undefined ? this.getDateFormat(this.product_prc_info.dcPriceStart) : null;  // 즉시할인 시작일 초기화
        this.dcPriceEnd = this.product_prc_info.dcPriceEnd != undefined ? this.getDateFormat(this.product_prc_info.dcPriceEnd) : null;        // 즉시할인 종료일 초기화
      }
    },    

    //추가상품 표시처리 & 초기화
    showAddPdtType() {
      this.showAddPdtType_flag = this.showAddPdtType_flag === "N" ? "Y" : "N";

      if(this.showAddPdtType_flag === "N") 
      {
          // 선택형 옵션 초기화
          this.tableHeadersForDB_add =  [];     // DB에 저장할 헤더
          this.tableHeaders_add = [];
          this.tableDataForDB_add = [];
          this.tableData_add = [];
          this.selectedRows_add = [];
          this.allSelected_add = false;
          this.fileName_add = '';
          this.file_add = null;
          this.optPrice_sel_add = ""
          this.qty_sel_add = ""
          this.useFlag_sel_add = ""
      }
    },

    // 추가상품 업로드시 날짜형 옵션 체크박스 클릭시
    checkAdd_dType(add_dType){
      this.add_dType = add_dType
    },

    //선택형옵션 표시처리 & 초기화
    showSellOptType() {
      this.showSellOptType_flag = this.showSellOptType_flag === "N" ? "Y" : "N";

      if(this.showSellOptType_flag === "N") 
      {
          // 선택형 옵션 초기화
          this.tableHeadersForDB =  [];     // DB에 저장할 헤더
          this.tableHeaders = [];
          this.tableDataForDB = [];
          this.tableData = [];
          this.selectedRows = [];
          this.allSelected = false;
          this.fileName = '';
          this.file = null;
          this.optPrice_sel = ""
          this.qty_sel= ""
          this.useFlag_sel = ""
      }
    },


    // 직접입력 옵션표시여부결정
    showDirOptType() {
      this.showDirOptType_flag = this.showDirOptType_flag === "N" ? "Y" : "N";

      if(this.showDirOptType_flag === "N") 
      {
        // 직접입력 옵션 초기화
        this.dirOptList = [{ name: '', useFlag: 'Y' }];
        this.dirOptCount = 1;
      }
    },    

    add_dirOpt() {
      if (this.dirOptList.length < 5) 
      {
        this.dirOptList.push({ name: '', useFlag: 'Y' });
        this.dirOptCount = this.dirOptList.length;
      }
    },
    del_dirOpt(idx) {
      if (this.dirOptList.length > 1) 
      {
        this.dirOptList.splice(idx, 1);
        this.dirOptCount = this.dirOptList.length;
      }
    },

    // 선택형 옵션 업로드시 날짜형 옵션 체크박스 클릭시
    checkdType(dType){
      this.dType = dType
    },

    // (신규) 날짜형 옵션의 월/일 문자열(예: "8월","08월","2일","02일")에서 숫자만 뽑아
    // 작업자별 0패딩 유무와 무관하게 2자리로 통일해서 반환
    normalizeOptDateSegment(str) {
      const digits = (str || '').slice(0, 2).match(/\d+/)?.[0];
      const num = Number(digits);
      return isNaN(num) ? '' : (num >= 10 ? String(num) : '0' + num);
    },

    // ==============================================
    // 엑셀 다운로드 (선택형옵션 / 직접형옵션 / 추가상품)
    // ==============================================

    // 공통 엑셀다운로드 함수: headers(배열) + rows(header키를 가진 객체배열)
    exportTableToExcel(headers, rows, fileName) {
      if(!rows || rows.length === 0)
      {
        this.$swal.fire("","다운로드할 데이터가 없습니다", "warning")
        return false;
      }
      if(!headers || headers.length === 0)
      {
        this.$swal.fire("","다운로드할 헤더 정보가 없습니다", "warning")
        return false;
      }

      const aoa = [headers, ...rows.map(row => headers.map(h => (row[h] != undefined ? row[h] : '')))];
      const worksheet = XLSX.utils.aoa_to_sheet(aoa);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, fileName);
    },

    // 선택형옵션 엑셀다운로드
    downloadSelOptExcel() {
      const fileName = `선택형옵션_${this.productId}_${dayjs().format('YYYYMMDD')}.xlsx`;
      // (수정) 날짜형 옵션이면 '적용연도' 컬럼도 함께 다운로드해서, 다시 올릴 때 그대로 인식되게 함
      if(this.dType === 'Y' && this.tableDataForDB.length > 0) {
        const headers = [...this.tableHeaders, '적용연도'];
        const rows = this.tableData.map((row, idx) => ({
          ...row,
          '적용연도': this.tableDataForDB[idx].appliedYear || ''
        }));
        this.exportTableToExcel(headers, rows, fileName);
      } else {
        this.exportTableToExcel(this.tableHeaders, this.tableData, fileName);
      }
    },

    // 직접형옵션 엑셀다운로드
    downloadDirOptExcel() {
      if(!this.dirOptList || this.dirOptList.length === 0)
      {
        this.$swal.fire("","다운로드할 데이터가 없습니다", "warning")
        return false;
      }
      const headers = ['옵션명', '사용여부'];
      const rows = this.dirOptList.map(opt => ({ '옵션명': opt.odName, '사용여부': opt.odUseFlag }));
      const fileName = `직접형옵션_${this.productId}_${dayjs().format('YYYYMMDD')}.xlsx`;
      this.exportTableToExcel(headers, rows, fileName);
    },

    // 추가상품 엑셀다운로드
    downloadAddPdtExcel() {
      const fileName = `추가상품_${this.productId}_${dayjs().format('YYYYMMDD')}.xlsx`;
      this.exportTableToExcel(this.tableHeaders_add, this.tableData_add, fileName);
    },

    // 선택삭제
    del_checkedOpt(param) {
      // 옵션
      if(param === "opt")
      {
        if (this.selectedRows.length === 0) 
        {
          this.$swal.fire('', '삭제할 행을 선택해주세요.', 'warning');
          return;
        }
        else
        {
          // 선택된 행의 인덱스를 기반으로 tableData에서 해당 행을 삭제
          this.selectedRows.sort((a, b) => b - a);                        // 역순으로 정렬하여 인덱스가 변경되지 않도록 함

          this.selectedRows.forEach(index => {
            this.tableData.splice(index, 1);
          });
        }

        this.selectedRows = [];
        this.allSelected = false; // 전체 선택 해제
      }

      // 추가상품
      else if(param === "add") 
      {
        if (this.selectedRows_add.length === 0) 
        {
          this.$swal.fire('', '삭제할 행을 선택해주세요.', 'warning');
          return;
        }
        else
        {
          // 선택된 행의 인덱스를 기반으로 tableData에서 해당 행을 삭제
          this.selectedRows_add.sort((a, b) => b - a);                // 역순으로 정렬하여 인덱스가 변경되지 않도록 함

          this.selectedRows_add.forEach(index => {
            this.tableData_add.splice(index, 1);
          });
        }

        this.selectedRows_add = [];
        this.allSelected_add = false; // 전체 선택 해제
      }
    },

    // 특정로우삭제
    del_selOptRow(param, idx) {
      //alert("idx: " + idx)
      if(param === "opt") 
      {
        this.tableData.splice(idx, 1);
      }
      else if(param === "add") 
      {
        this.tableData_add.splice(idx, 1);
      }
    },


    toggleAll(param) {

      if (param === "opt") 
      {
        this.selectedRows = this.allSelected ? this.tableData.map(row => row.osSeq) : [];
      }
      // if (param === "add") 
      // {
      //   this.selectedRows_add = this.allSelected_add ? this.tableData_add.map(row => row.osSeq) : [];
      // }

      // // map: 선택된 행의 인덱스를 가져와서 selectedRows에 저장
      // if(param === "opt") 
      // {
      //   this.selectedRows = this.allSelected ? this.tableData.map((_, index) => index) : [];
      // }

      if(param === "add") 
      {
        this.selectedRows_add = this.allSelected_add ? this.tableData_add.map((_, index) => index) : [];
      }
    },


    // 선택형 옵션 화면업로드
    onFileSelected(e) {
      this.file = e.target.files[0];
      this.fileName = this.file ? this.file.name : '';

      if (!this.file) {
        alert('엑셀 파일을 선택해주세요.');
        return false;
      }

      const reader = new FileReader();
      reader.onload = (evt) => {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const firstSheet = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheet];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: ''
        });

        // (수정) 엑셀 마지막 컬럼이 '적용연도'인 경우 분리해서 처리
        // → 기존 "날짜 오름차순 정렬 + 월이 감소하는 지점을 연도경계로 추정"하던 로직 폐기.
        //    값이 있으면 그대로 사용, 공란이면 저장 시 상단 기본연도(this.osYear)를 사용.
        let rawHeaders = [...jsonData[0]];
        let yearColIdx = -1;
        if (rawHeaders[rawHeaders.length - 1] === '적용연도') {
          yearColIdx = rawHeaders.length - 1;
          rawHeaders = rawHeaders.slice(0, -1);
        }
        const getAppliedYear = (row) => {
          if (yearColIdx < 0) return '';
          const v = row[yearColIdx];
          return (v != undefined && String(v).trim() !== '') ? String(v).trim() : '';
        };

        this.tableHeaders = rawHeaders;
        this.tableHeadersForDB = rawHeaders;

        // 화면용 데이터 (엑셀 그대로)
        this.tableData = jsonData.slice(1).map(row => {
          const obj = {};
          this.tableHeaders.forEach((header, index) => {
            obj[header] = row[index] != undefined ? String(row[index]).trim() : '';
          });
          obj.appliedYear = getAppliedYear(row);   // (추가) 행별 적용연도(공란 가능)
          return obj;
        });

        // DB 저장용 데이터 (os2, os3 추가)
        let tbHeaderCount = this.tableHeaders.length;
        this.nullHeaderCount = 7 - tbHeaderCount;

        this.uploadedNullHeaderCount = this.nullHeaderCount; // 업로드된 null 헤더 갯수

        //console.log("nullHeaderCount1.....: ", this.nullHeaderCount);
        

        // DB 저장용 헤더 생성 (os2, os3 추가)
        let dbHeaders = [...this.tableHeaders];
        if (this.nullHeaderCount === 2) 
        {
          dbHeaders.splice(1, 0, 'os2', 'os3');
        } 
        else if (this.nullHeaderCount === 1) 
        {
          dbHeaders.splice(2, 0, 'os3');
        }
        this.tableHeadersForDB = dbHeaders;

        // DB 저장용 데이터 생성 (데이터도 중간에 null 삽입)
        this.tableDataForDB = jsonData.slice(1).map(row => {
          let adjustedRow = [...row];
          if (this.nullHeaderCount === 2) 
          {
            adjustedRow.splice(1, 0, null, null); // os2, os3 자리에 null 추가
          } 
          else if (this.nullHeaderCount === 1) 
          {
            adjustedRow.splice(2, 0, null); // os3 자리에 null 추가
          }
          const obj = {};
          this.tableHeadersForDB.forEach((header, index) => {
            obj[header] = adjustedRow[index] != undefined ? String(adjustedRow[index]).trim() : '';
          });
          obj.appliedYear = getAppliedYear(row);   // (추가) 원본 row(적용연도 컬럼 포함) 기준으로 추출
          return obj;
        });
      };
      reader.readAsBinaryString(this.file);
    },


    // 추가상품 화면업로드
    onFileSelected_add(e) {
      this.file_add = e.target.files[0];
      this.fileName_add = this.file_add ? this.file_add.name : '';

      if (!this.file_add) {
        alert('엑셀 파일을 선택해주세요.');
        return false;
      }

      const reader = new FileReader();
      reader.onload = (evt) => {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const firstSheet = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheet];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: ''
        });

        this.tableHeadersForDB_add = jsonData[0];
        this.tableHeaders_add = jsonData[0];

        // 화면용 데이터 (엑셀 그대로)
        this.tableHeaders_add = jsonData[0];
        this.tableData_add = jsonData.slice(1).map(row => {
          const obj = {};
          this.tableHeaders_add.forEach((header, index) => {
            obj[header] = row[index] != undefined ? String(row[index]).trim() : '';
          });
          return obj;
        });

        // DB 저장용 데이터 (os2, os3 추가)
        let tbHeaderCount = this.tableHeaders_add.length;
        this.nullHeaderCount_add = 7 - tbHeaderCount;

        this.uploadedNullHeaderCount_add = this.nullHeaderCount_add; // 업로드된 null 헤더 갯수

        // DB 저장용 헤더 생성 (os2, os3 추가)
        let dbHeaders = [...this.tableHeaders_add];
        if (this.nullHeaderCount_add === 2) 
        {
          dbHeaders.splice(1, 0, 'add2', 'add3');
        } 
        else if (this.nullHeaderCount_add === 1) 
        {
          dbHeaders.splice(2, 0, 'add3');
        }
        this.tableHeadersForDB_add = dbHeaders;

        // DB 저장용 데이터 생성 (데이터도 중간에 null 삽입)
        this.tableDataForDB_add = jsonData.slice(1).map(row => {
          let adjustedRow = [...row];
          if (this.nullHeaderCount_add === 2) 
          {
            adjustedRow.splice(1, 0, null, null); // os2, os3 자리에 null 추가
          } 
          else if (this.nullHeaderCount_add === 1) 
          {
            adjustedRow.splice(2, 0, null); // os3 자리에 null 추가
          }
          const obj = {};
          this.tableHeadersForDB_add.forEach((header, index) => {
            obj[header] = adjustedRow[index] != undefined ? String(adjustedRow[index]).trim() : '';
          });
          return obj;
        });
      };
      reader.readAsBinaryString(this.file_add);
    },


    goToList() {
      // (수정) salesMix(혼합상품) 테이블 미사용 확정 → pdtFlag 분기 제거, /sales로 고정
      this.$router.push({path: '/sales'});
    },

    goToCheckPage(pCode, sCode) {
      const url = this.$router.resolve({
        path: '/productDetail_check',
        query: { productId: pCode, salesRoute: sCode }
      }).href;
      window.open(url, '_blank');
    },

    async upd_checkedOpt(param) {
      if(param === "opt") 
      {
        if (this.selectedRows.length === 0) 
        {
          this.$swal.fire('', '선택된 행이 없습니다.', 'warning');
          return;
        }
        else 
        {
          this.$swal.fire('', '옵션가, 재고수량, 사용여부만 수정이 가능합니다.', 'info').then(async () =>{
            let nHD = this.product_opt_sel_info.nullHDCount;
            //console.log("nullHeaderCount: ", nHD);

            let failedRows = [];
            let successRows = 0;

            for (let i = 0; i < this.selectedRows.length; i++) {
              let osSeqVal = this.selectedRows[i];
              // osSeq를 기반으로 해당 행의 인덱스 찾기
              let idx = this.tableData.findIndex(row => row.osSeq === osSeqVal);
              
              if(idx === -1) 
              {
                failedRows.push(i + 1);
                continue;
              }

              // (수정) nullHDCount 삼중분기 → optionTableMixin.getOptColumnIndexes()로 대체
              const colIdx = this.getOptColumnIndexes(nHD);
              let osPrice    = this.tableData[idx][this.tableHeaders[colIdx.price]];
              let osQty      = this.tableData[idx][this.tableHeaders[colIdx.qty]];
              let osMaCode   = this.tableData[idx][this.tableHeaders[colIdx.maCode]];
              let sellStatus = this.tableData[idx][this.tableHeaders[colIdx.status]];
              // console.log("osPrice, osQty, osMaCode, sellStatus, osSeqVal: ", osPrice, osQty, osMaCode, sellStatus, osSeqVal)
              let upd_selOptValue = await this.$api("/api/updSelOptValue", {param: [
                  osPrice, osQty, osMaCode, sellStatus, this.user.handlerId, osSeqVal  // (수정) handerId → handlerId 오타
              ]});

              if(upd_selOptValue.affectedRows > 0) 
              {
                successRows++;
              }
              else 
              {
                failedRows.push(i + 1); // 몇번째 행이 실패했는지 저장
              }
            }

            if (successRows === this.selectedRows.length) 
            {
              this.$swal.fire('', '선택된 옵션값으로 모두 업데이트 되었습니다.', 'success');
              location.reload(true); // 전체 성공 시 새로고침
            } 
            else if (successRows > 0) 
            {
              this.$swal.fire('', `일부 옵션(${failedRows.join(', ')})의 업데이트에 문제가 있습니다.`, 'warning');
            } 
            else 
            {
              this.$swal.fire('', '모든 옵션값 업데이트에 실패하였습니다.', 'error');
              return false;
            }
          });
        }
      }

      //추가상품 퀵수정
      else if(param === "add") 
      {
        if (this.selectedRows_add.length === 0) 
        {
          this.$swal.fire('', '선택된 행이 없습니다.', 'warning');
          return;
        }
        else 
        {
          this.$swal.fire('', '추가상품가, 재고수량, 사용여부만 수정이 가능합니다.', 'info').then(async () =>{
            let nHD = this.product_addpdt_m_info.add_nullHDCount
            let i = 0
            let idx = ""
            //let selectedParams = []
            let add1 = ""
            let add2 = ""
            let add3 = ""
            let addPrice  = ""
            let addQty    = ""
            let addMaCode = ""
            let addStatus = ""

            // 쿼리반복수행 결과처리
            let failedRows = []
            let successRows = 0

            while(i < this.selectedRows_add.length) 
            {
              idx = this.selectedRows_add[i]
              //selectedParams = this.tableData[idx]
              //os1 = this.tableData[idx][this.tableHeader[0]]

              // (수정) nullHDCount 삼중분기 → optionTableMixin 메서드로 대체
              const nameVals = this.getOptNameValues(this.tableData_add[idx], this.tableHeaders_add, nHD);
              add1 = nameVals.name1;
              add2 = nameVals.name2;
              add3 = nameVals.name3;

              const colIdxAdd = this.getOptColumnIndexes(nHD, true); // (2026-07-10) add는 사용여부/관리코드 순서가 opt와 반대
              addPrice  = this.tableData_add[idx][this.tableHeaders_add[colIdxAdd.price]];
              addQty    = this.tableData_add[idx][this.tableHeaders_add[colIdxAdd.qty]];
              addMaCode = this.tableData_add[idx][this.tableHeaders_add[colIdxAdd.maCode]];
              addStatus = this.tableData_add[idx][this.tableHeaders_add[colIdxAdd.status]];

              let updSelAddPdtValue = await this.$api("/api/updSelAddPdtValue", {param: [
                addPrice, addQty, addMaCode, addStatus, this.user.handlerId, add1, add2, add3  // (수정) handerId → handlerId 오타
              ]});

              if(updSelAddPdtValue.affectedRows > 0) 
              {
                successRows++
              }
              else 
              {
                failedRows.push(i+1) // 몇번째 행이 실패했는지 저장
              }
              i++
            }

            if(successRows == this.selectedRows_add.length) 
            {
              this.$swal.fire('', '선택된 추가상품값으로 모두 업데이트 되었습니다.', 'success');
              location.reload(true); // 페이지 새로고침
            }
            else if (successRows > 0 && failedRows.length > 0)
            {
              this.$swal.fire('', `일부 행(${failedRows.join(', ')}) 업데이트에 문제가 발생하였습니다.`, 'warning');
            }
            else 
            {
              this.$swal.fire('', '전체행의 업데이트에 문제가 발생하였습니다.', 'error');
              return false;
            } 
          })
        }
      }
    },

    updateOptionValue(param) {
      // 선택옵션
      if(param === "opt") 
      {
        // 선택된 행이 없으면 경고 메시지 표시
        if (this.selectedRows.length === 0) {
          this.$swal.fire('', '선택된 행이 없습니다.', 'warning');
          return;
        }
        if(!this.optPrice_sel && !this.qty_sel && !this.useFlag_sel) 
        {
          this.$swal.fire('', '옵션가격, 재고수량, 사용여부 중 하나 이상을 입력해주세요.', 'warning');
          return;
        }

        this.nullHeaderCount = this.product_opt_sel_info.nullHDCount == undefined ? this.nullHeaderCount : this.product_opt_sel_info.nullHDCount;

        // if(this.priceAri === "Y") 
        // {
        //   this.nullHeaderCount = this.uploadedNullHeaderCount == this.nullHeaderCount ? this.nullHeaderCount : this.uploadedNullHeaderCount; // 업로드된 null 헤더 갯수로 설정
        // }


        if(this.allSelected) 
        {
          if(this.optPrice_sel != "" && this.optPrice_sel != 0) 
          {
            this.$swal.fire("","※ 네이버스마트스토어와 데이타를 공유하기 위해서는<br>최소 1개 이상의 옵션가격이 0원이어야 합니다.", "warning")
            //return false;
          }

          // (수정) nullHeaderCount 삼중분기 → optionTableMixin.getOptColumnIndexes()로 통합
          const colIdx = this.getOptColumnIndexes(this.nullHeaderCount);

          // 전체 선택된 경우, 모든 행에 선택한 값 적용
          this.tableData.forEach((row) => {
            row[this.tableHeaders[colIdx.price]]  = (this.optPrice_sel == "") ? row[this.tableHeaders[colIdx.price]]  : this.optPrice_sel   // 선택형옵션가격
            row[this.tableHeaders[colIdx.qty]]    = (this.qty_sel == "")      ? row[this.tableHeaders[colIdx.qty]]    : this.qty_sel        // 선택형옵션수량
            row[this.tableHeaders[colIdx.status]] = (this.useFlag_sel == "")  ? row[this.tableHeaders[colIdx.status]] : this.useFlag_sel     // 선택형옵션사용여부
          });

          //저장은 nullHeaderCount ==0 에 맞춰서 진행 (DB저장용 헤더는 항상 고정 7컬럼 구조)
          const colIdxDB = this.getOptColumnIndexes(0);
          this.tableDataForDB.forEach((row) => {
            row[this.tableHeadersForDB[colIdxDB.price]]  = (this.optPrice_sel == "") ? row[this.tableHeadersForDB[colIdxDB.price]]  : this.optPrice_sel   // 선택형옵션가격
            row[this.tableHeadersForDB[colIdxDB.qty]]    = (this.qty_sel == "")      ? row[this.tableHeadersForDB[colIdxDB.qty]]    : this.qty_sel        // 선택형옵션수량
            row[this.tableHeadersForDB[colIdxDB.status]] = (this.useFlag_sel == "")  ? row[this.tableHeadersForDB[colIdxDB.status]] : this.useFlag_sel    // (버그수정) 자기참조로 통일 - 이전엔 관리코드 컬럼을 잘못 참조
          });
        }
        else 
        {
          // (수정) nullHeaderCount 삼중분기 → mixin으로 통합
          const colIdx = this.getOptColumnIndexes(this.nullHeaderCount);
          const colIdxDB = this.getOptColumnIndexes(0); // DB저장용은 항상 고정 7컬럼 구조

          // 선택된 행에만 값 적용
          this.selectedRows.forEach(osSeqValue => {
            // 식별자가 저장된 selectedRows 값으로 tableData에서 인덱스 찾기
            const index = this.tableData.findIndex(row => row.osSeq === osSeqValue);
            if(index !== -1) {
              let row = this.tableData[index];
              row[this.tableHeaders[colIdx.price]]  = (this.optPrice_sel === "") ? row[this.tableHeaders[colIdx.price]]  : this.optPrice_sel;
              row[this.tableHeaders[colIdx.qty]]    = (this.qty_sel === "")      ? row[this.tableHeaders[colIdx.qty]]    : this.qty_sel;
              row[this.tableHeaders[colIdx.status]] = (this.useFlag_sel === "")  ? row[this.tableHeaders[colIdx.status]] : this.useFlag_sel;
            }

            // DB 저장용 데이터에도 같은 방식 적용
            const dbIndex = this.tableDataForDB.findIndex(row => row.osSeq === osSeqValue);
            if(dbIndex !== -1) {
              let rowDB = this.tableDataForDB[dbIndex];
              rowDB[this.tableHeadersForDB[colIdxDB.price]]  = (this.optPrice_sel === "") ? rowDB[this.tableHeadersForDB[colIdxDB.price]]  : this.optPrice_sel;
              rowDB[this.tableHeadersForDB[colIdxDB.qty]]    = (this.qty_sel === "")      ? rowDB[this.tableHeadersForDB[colIdxDB.qty]]    : this.qty_sel;
              rowDB[this.tableHeadersForDB[colIdxDB.status]] = (this.useFlag_sel === "")  ? rowDB[this.tableHeadersForDB[colIdxDB.status]] : this.useFlag_sel; // (버그수정) 자기참조로 통일
            }
          });
        }
      }

      // 추가상품
      else if(param === "add") 
      {
        // 선택된 행이 없으면 경고 메시지 표시
        if (this.selectedRows_add.length === 0) {
          this.$swal.fire('', '선택된 행이 없습니다.', 'warning');
          return;
        }
        if(!this.optPrice_sel_add && !this.qty_sel_add && !this.useFlag_sel_add) 
        {
          this.$swal.fire('', '추가상품가, 재고수량, 사용여부 중 하나 이상을 입력해주세요.', 'warning');
          return;
        }
        this.nullHeaderCount_add = this.product_addpdt_m_info.add_nullHDCount == undefined ? this.nullHeaderCount_add : this.product_addpdt_m_info.add_nullHDCount;

        if(this.allSelected_add) 
        {
          // 네이버 정책에 따라 추가상품가격은 -불가
          if(this.optPrice_sel_add != "" && this.optPrice_sel_add < 0) 
          {
            this.$swal.fire("","※ 추가상품가격은 0원 이상이어야 합니다", "warning")
            return false;
          }

          // (수정) nullHeaderCount_add 삼중분기 → optionTableMixin.getOptColumnIndexes()로 통합
          const colIdx = this.getOptColumnIndexes(this.nullHeaderCount_add, true); // add는 사용여부/관리코드 순서가 opt와 반대

          // 전체 선택된 경우, 모든 행에 선택한 값 적용
          this.tableData_add.forEach((row) => {
            row[this.tableHeaders_add[colIdx.price]]  = (this.optPrice_sel_add == "") ? row[this.tableHeaders_add[colIdx.price]]  : this.optPrice_sel_add   // 추가상품가격
            row[this.tableHeaders_add[colIdx.qty]]    = (this.qty_sel_add == "")      ? row[this.tableHeaders_add[colIdx.qty]]    : this.qty_sel_add        // 추가상품수량
            row[this.tableHeaders_add[colIdx.status]] = (this.useFlag_sel_add == "")  ? row[this.tableHeaders_add[colIdx.status]] : this.useFlag_sel_add    // 추가상품사용여부
          });

          //저장은 nullHeaderCount_add ==0 에 맞춰서 진행 (DB저장용 헤더는 항상 고정 7컬럼 구조)
          const colIdxDB = this.getOptColumnIndexes(0, true);
          this.tableDataForDB_add.forEach((row) => {
            row[this.tableHeadersForDB_add[colIdxDB.price]]  = (this.optPrice_sel_add == "") ? row[this.tableHeadersForDB_add[colIdxDB.price]]  : this.optPrice_sel_add   // 추가상품가격
            row[this.tableHeadersForDB_add[colIdxDB.qty]]    = (this.qty_sel_add == "")      ? row[this.tableHeadersForDB_add[colIdxDB.qty]]    : this.qty_sel_add        // 추가상품수량
            row[this.tableHeadersForDB_add[colIdxDB.status]] = (this.useFlag_sel_add == "")  ? row[this.tableHeadersForDB_add[colIdxDB.status]] : this.useFlag_sel_add    // (버그수정) 자기참조로 통일
          });
        }
        else 
        {
          // (수정) nullHeaderCount_add 삼중분기 → mixin으로 통합
          const colIdx = this.getOptColumnIndexes(this.nullHeaderCount_add, true); // add는 사용여부/관리코드 순서가 opt와 반대
          const colIdxDB = this.getOptColumnIndexes(0, true); // DB저장용은 항상 고정 7컬럼 구조

          // 선택된 행에만 값 적용 (화면표시용)
          this.selectedRows_add.forEach((index) => {
            let row = this.tableData_add[index];
            row[this.tableHeaders_add[colIdx.price]]  = (this.optPrice_sel_add == "") ? row[this.tableHeaders_add[colIdx.price]]  : this.optPrice_sel_add;    // (버그수정) 자기참조로 통일
            row[this.tableHeaders_add[colIdx.qty]]    = (this.qty_sel_add == "")      ? row[this.tableHeaders_add[colIdx.qty]]    : this.qty_sel_add;
            row[this.tableHeaders_add[colIdx.status]] = (this.useFlag_sel_add == "")  ? row[this.tableHeaders_add[colIdx.status]] : this.useFlag_sel_add;      // (버그수정) 자기참조로 통일
          });

          //저장은 nullHeaderCount_add ==0 에 맞춰서 진행
          this.selectedRows_add.forEach((index) => {
            let row = this.tableDataForDB_add[index];
            row[this.tableHeadersForDB_add[colIdxDB.price]]  = (this.optPrice_sel_add == "") ? row[this.tableHeadersForDB_add[colIdxDB.price]]  : this.optPrice_sel_add;
            row[this.tableHeadersForDB_add[colIdxDB.qty]]    = (this.qty_sel_add == "")      ? row[this.tableHeadersForDB_add[colIdxDB.qty]]    : this.qty_sel_add;
            row[this.tableHeadersForDB_add[colIdxDB.status]] = (this.useFlag_sel_add == "")  ? row[this.tableHeadersForDB_add[colIdxDB.status]] : this.useFlag_sel_add;   // (버그수정) 자기참조로 통일
          });
        }
      }
    },

    //직접형 옵션만 변경
    async changeOpt_dir(oCode) {
      let timeStamp = "";
      let today = new Date();
      let yyyy = today.getFullYear();
      let mm = today.getMonth()+1;
      let dd = today.getDate();
      let ymd = `${yyyy}${mm}${dd}`
      timeStamp = today.getTime();

      let odCode = "OD" + "-"+ymd+"-"+timeStamp;                          // 직접형 옵션코드

      let prCode = this.product_prc_info.prcCode

      // 직접형 옵션미비검증
      if(this.showDirOptType_flag === "Y") 
      {
        // 직접형 옵션이 없으면 경고
        if(this.dirOptList.length == 0) 
        {
          this.$swal.fire("","직접입력 옵션이 없습니다", "warning")
          return false
        }
        else 
        {
          // 직접형 옵션명 검증
          for(let opt of this.dirOptList) 
          {
            if(opt.odName.trim() == "") 
            {
              return this.$swal.fire("","직접형옵션의 옵션명이 없습니다", "warning")
            }
          }
        }
      }

      //직접입력 옵션이 있는 경우
      if(this.showDirOptType_flag === "Y")
      {
        this.isSaving = true;
        this.$loading.start();        
        
        ////변경대응
        if(this.priceAri == "Y")
        {
          let odUseFlag = "N"
          let upd_product_opt_dir_m_stat = await this.$api("/api/upd_product_opt_dir_m_stat", {param: [
            odUseFlag, this.user.handlerId, oCode, prCode
          ]});
          if(upd_product_opt_dir_m_stat.affectedRows < 0)
          {
            this.$swal.fire("","가격/옵션 수정 중에 문제가 발생하였습니다. 관리자에게 문의해 주세요", "error")
            return false;
          }
          else
          {
            this.$swal.fire("","직접형 옵션설정에 변경사항이 없습니다", "info")
          }              
        }
        if(this.dirOptList.length < 1)
        {
          this.$swal.fire("","직접입력 옵션이 없습니다", "warning")
          return false
        }
        else 
        {
          let odUseFlag = "Y"
          // 직접입력옵션 마스타등록
          let ins_product_opt_dir_m = await this.$api("/api/ins_product_opt_dir_m", {param: [
            this.productId, odCode, odUseFlag, this.user.handlerId, prCode
          ]});
          if(ins_product_opt_dir_m.affectedRows > 0) 
          {
            ////변경대응
            if(this.priceAri == "Y")
            {
              let odUseFlag = "N"
              let upd_product_opt_dir_d_stat = await this.$api("/api/upd_product_opt_dir_d_stat", {param: [
                odUseFlag, this.user.handlerId, oCode
              ]});
              if(upd_product_opt_dir_d_stat.affectedRows < 0)
              {
                this.$swal.fire("","가격/옵션 수정 중에 문제가 발생하였습니다. 관리자에게 문의해 주세요", "error")
                return false;
              }
            }
            
            // 직접입력 옵션 등록
            let i = 0
            for(let dirOpt of this.dirOptList) 
            {
              i++;
              let ins_product_opt_dir_d = await this.$api("/api/ins_product_opt_dir_d", {param: [
                odCode, i, dirOpt.odName, dirOpt.odUseFlag, this.user.handlerId
              ]});
              if(ins_product_opt_dir_d.affectedRows < 0) 
              {
                await this.$api("/api/insOptPdtInfo_dir_fail", {param: [odCode]});  // 등록실패시, 무효화처리
                
                this.isSaving = false;
                this.$loading.finish();       //인디케이터 중지
                
                this.$swal.fire("","직접형 옵션등록 중에러가 발생했습니다. 재시도해주세요", "warning")
                return false;
              }
            }
          }
        }

        this.isSaving = false;
        this.$loading.finish();       //인디케이터 중지
        
        this.$swal.fire("","상품가격이 등록되었습니다.", "success").then(() => 
        {
          location.reload(true)
        })        
      }
      else 
      {
        console.log("직접형 옵션이 없어 저장하지 않습니다.")
      }

    },


    // new 가격등록 (추가상품등록 추가: 20250828)
    async priceInsert_new() {
      //PriceCode 생성
      let timeStamp = "";
      let today = new Date();
      let yyyy = today.getFullYear();
      let mm = today.getMonth()+1;
      let dd = today.getDate();
      let ymd = `${yyyy}${mm}${dd}`
      timeStamp = today.getTime();                                        // 상품코드에 들어갈 타임스탬프
      let catCode = "P"+this.productInfo.salesRoute;

      let prcCode = catCode+"-"+ymd+"-"+timeStamp;
      let useFlag = 'Y'
      let insId = this.user.handlerId;                                    // 등록자ID  
      let priceClass = this.salesRoute;                                   // 상품카테고리

      // 가격옵션
      let osCode = "OS" + "-"+ymd+"-"+timeStamp;                          // 선택형 옵션코드
      let odCode = "OD" + "-"+ymd+"-"+timeStamp;                          // 직접형 옵션코드
      let addCode = "AD" + "-"+ymd+"-"+timeStamp;                         // 추가상품코드

      let osName1 = this.tableHeaders[0];                           // 선택옵션명1
      let osName2 = this.tableHeaders[1];                           // 선택옵션명2
      let osName3 = this.tableHeaders[2];                           // 선택옵션명3
      let osUseFlag = "Y";                                                // 옵션사용여부

      let addName1 = this.tableHeaders_add[0];                      // 추가상품명1
      let addName2 = this.tableHeaders_add[1];                      // 추가상품명2
      let addName3 = this.tableHeaders_add[2];                      // 추가상품명3
      let addUseFlag = "Y";                                               // 추가상품사용여부      

      if(this.bsPriceStart) 
      {
        if(!this.bsPriceEnd)
        {
          return this.$swal.fire("","판매기간 종료일을 입력하세요","warning")
        }
      }
      if(this.bsPriceEnd) 
      {
        if(!this.bsPriceStart)
        {
          return this.$swal.fire("","판매기간 시작일을 입력하세요","warning")
        }
      }

      // 판매가 검증
      if(!this.basicPrice || this.basicPrice < 10) 
      {
        this.$refs.basicPrice.focus()
        return this.$swal.fire("","판매가를 입력하세요(10원 이상)", "warning")
      }
      else 
      {
        this.basicPrice = Math.floor(this.basicPrice/10)*10;              // 판매가 10원단위로 맞추기
      }


      // 즉시할인액 검증
      if(this.showDC_flag === 'Y')
      {
        if(this.dcMethod === "A")
        {
          if(!this.dcPrice || this.dcPrice < 10) 
          {
            return this.$swal.fire("","즉시할인액을 입력하세요(10원 이상)", "warning")
          }
          else 
          {
            this.dcPrice = Math.floor(this.dcPrice/10)*10;                  // 즉시할인액 10원단위로 맞추기
          }
        }
        else if(this.dcMethod === "P")
        {
          if(!this.dcPrice || this.dcPrice < 1 || this.dcPrice >= 100) 
          {
            return this.$swal.fire("","즉시할인율을 적절하게 입력하세요(1% ~ 100%)", "warning")
          }
          else
          {
            this.dcPrice = Math.floor(this.dcPrice);                        // 소숫점 이하 절차처리
          }
        }
        else 
        {
          return this.$swal.fire("","할인방법을 선택하세요(할인액 또는 할인율 택1)", "warning")
        }
      }

      // 선택형 옵션미비검증
      if(this.showSellOptType_flag === "Y") 
      {
        if(this.tableData.length === 0) 
        {
          this.$swal.fire("","선택형 옵션이 없습니다", "warning")
          return false
        }
        else if(this.selectedRows.length > 0) 
        {
          // 선택된 행만 검증
          for(let index of this.selectedRows) 
          {
            let row = this.tableData[index];
            row[this.tableHeaders[3]] = (row[this.tableHeaders[3]] == "") ? 0 : row[this.tableHeaders[3]];            // 선택형옵션가격
          }
        }
        // 선택된 행이 없으면 전체 행에 대해 검증
        else if(this.selectedRows.length == 0 && this.tableData.length > 0) 
        {
          for(let row of this.tableData) 
          {
            row[this.tableHeaders[3]] = (row[this.tableHeaders[3]] == "") ? 0 : row[this.tableHeaders[3]];            // 선택형옵션가격
          }
        }
      }

      // 직접형 옵션미비검증
      if(this.showDirOptType_flag === "Y") 
      {
        // 직접형 옵션이 없으면 경고
        if(this.dirOptList.length == 0) 
        {
          this.$swal.fire("","직접입력 옵션이 없습니다", "warning")
          return false
        }
        else 
        {
          // 직접형 옵션명 검증
          for(let opt of this.dirOptList) 
          {
            if(opt.odName.trim() == "") 
            {
              return this.$swal.fire("","직접형옵션의 옵션명이 없습니다", "warning")
            }
          }
        }
      }

      // 추가상품 미비검증
      if(this.showAddPdtType_flag === "Y") 
      {
        if(this.tableData_add.length === 0) 
        {
          this.$swal.fire("","추가상품이 없습니다", "warning")
          return false
        }
        else if(this.selectedRows_add.length > 0) 
        {
          // 선택된 행만 검증
          for(let index of this.selectedRows_add)  
          {
            let row = this.tableData_add[index];
            row[this.tableHeaders_add[2]] = (row[this.tableHeaders_add[2]] == "") ? 0 : row[this.tableHeaders_add[2]];            // 추가상품가격

            if(row[this.tableHeaders_add[2]] < 0) 
            {
              this.$swal.fire("","추가상품가격은 0원 이상이어야 합니다", "warning")
              return false
            }
          }
        }
        // 선택된 행이 없으면 전체 행에 대해 검증
        else if(this.selectedRows_add.length == 0 && this.tableData_add.length > 0) 
        {
          for(let row of this.tableData_add) 
          {
            row[this.tableHeaders_add[3]] = (row[this.tableHeaders_add[3]] == "") ? 0 : row[this.tableHeaders_add[3]];            // 선택형옵션가격

            if(row[this.tableHeaders_add[2]] < 0) 
            {
              this.$swal.fire("","추가상품가격은 0원 이상이어야 합니다", "warning")
              return false
            }            
          }
        }
      }

      //1차결제금액 업데이트
      let ins_firstPayInfo = await this.$api("/api/ins_firstPayInfo", {param: [
        this.productInfo.firstPayment, "P", this.productId
      ]})

      if(ins_firstPayInfo.affectedRows < 0)
      {
        this.$swal.fire("","결제방법 저장 중 에러가 발생했습니다. 재시도해주세요", "warning")
        return false;
      }

      // valid체크 후 저장로딩시작
      this.isSaving = true;
      this.$loading.start();

      // 저장단계별로 기존가격이 있으면 기존 정보 무효화 후 인서트한다

      let bsPriceStart = (this.bsPriceStart == undefined || this.bsPriceStart == "") ? null : this.bsPriceStart
      let bsPriceEnd   = (this.bsPriceEnd   == undefined || this.bsPriceEnd   == "") ? null : this.bsPriceEnd
      let dcPriceStart = (this.dcPriceStart == undefined || this.dcPriceStart == "") ? null : this.dcPriceStart
      let dcPriceEnd   = (this.dcPriceEnd   == undefined || this.dcPriceEnd   == "") ? null : this.dcPriceEnd

      if(this.priceAri == "Y")
      {
        let prcUseFlag = "N"
        let upd_product_prc_stat = await this.$api("/api/upd_product_prc_stat", {param: [
          prcUseFlag, this.user.handlerId, this.productId, this.product_prc_info.prcCode
        ]});
        if(upd_product_prc_stat.affectedRows < 0)
        {
          this.$swal.fire("","가격/옵션 수정 중에 문제가 발생하였습니다. 관리자에게 문의해 주세요", "error")
          return false;
        }
        // (수정) "가격설정에 변경사항이 없습니다" info 팝업 제거 - 저장완료/에러 알림만 남기기 위함
      }

      // 상품가격 기본정보 등록
      let ins_product_prc = await this.$api("/api/ins_product_prc", {param: [
        this.productId, prcCode, this.basicPrice, useFlag, insId, priceClass, bsPriceStart, bsPriceEnd, this.showDC_flag, this.dcPrice, this.dcMethod, dcPriceStart, dcPriceEnd, this.showSellOptType_flag, this.showDirOptType_flag, this.showAddPdtType_flag
      ]});

        if(ins_product_prc.affectedRows > 0)
        {
          //선택형 옵션이 있는 경우
          if(this.showSellOptType_flag === "Y")
          {
            ////변경대응
            if(this.priceAri == "Y")
            {
              let osUseFlag = "N"
              let upd_product_opt_sel_m_stat = await this.$api("/api/upd_product_opt_sel_m_stat", {param: [
                osUseFlag, this.user.handlerId, this.product_opt_sel_info.osCode, this.product_opt_sel_info.prcCode
              ]});
              if(upd_product_opt_sel_m_stat.affectedRows < 0)
              {
                this.$swal.fire("","가격/옵션 수정 중에 문제가 발생하였습니다-CaseI. 관리자에게 문의해 주세요", "error")
                return false;
              }
            }

            let ins_product_opt_sel_m = await this.$api("/api/ins_product_opt_sel_m", {param: [
              osCode, osName1, osName2, osName3, osUseFlag, this.user.handlerId, this.dType, prcCode, this.nullHeaderCount
            ]});

            if(ins_product_opt_sel_m.affectedRows > 0) 
            {
              ////변경대응
              if(this.priceAri == "Y")
              {
                let osUse = "N"
                let upd_product_opt_sel_d_stat = await this.$api("/api/upd_product_opt_sel_d_stat", {param: [
                  osUse, this.user.handlerId, this.product_opt_sel_info.osCode
                ]});
                if(upd_product_opt_sel_d_stat.affectedRows < 0)
                {
                  this.$swal.fire("","가격/옵션 수정 중에 문제가 발생하였습니다-CaseII. 관리자에게 문의해 주세요", "error")
                  return false;
                }
                // (수정) "선택형 옵션설정에 변경사항이 없습니다" info 팝업 제거
              }

              // 날짜형 옵션인 경우
              if(this.dType === "Y")
              {
                // (수정) 기존 nextYearFlag / rowYears 방식 폐기.
                // 기존 로직: 배치 안에 10·11·12월이 "하나라도" 있으면 nextYearFlag=Y로 두고,
                //           그 배치의 모든 <10월 행을 무조건 osYear+1로 처리했음.
                // → "9,10,11월(같은해, 안넘어감)"과 "11,12,1,2,3월(해넘어감)"이 둘 다
                //    "배치 안에 10 이상과 10 미만이 섞여있다"는 동일한 패턴을 만들기 때문에
                //    두 경우를 구분하지 못하고, 9월처럼 정상적인 데이터까지 내년으로 잘못 저장하는 문제가 있었음.
                // → 엑셀 '적용연도' 컬럼값(row.appliedYear)을 우선 사용하고,
                //    공란이면 상단에서 체크한 기본연도(this.osYear)를 사용하도록 단순화.
                //    (정렬 여부 확인/보정은 하지 않음 - 더 이상 정렬에 의존하지 않음)

                // 업로드할 옵션을 선택하지 않으면 전체업로드
                if(this.selectedRows.length === 0) 
                {
                  for(let i = 0; i < this.tableDataForDB.length; i++) {
                    let row = this.tableDataForDB[i];
                    let osYear = row.appliedYear || this.osYear;   // (수정) 엑셀 '적용연도' 우선, 공란이면 기본연도

                    let os1 = row[this.tableHeadersForDB[0]];
                    let os2 = row[this.tableHeadersForDB[1]];

                    // (수정) "8월"/"08월"처럼 0패딩 유무가 작업자마다 달라서 생기던 자릿수 오류 수정
                    let osDate1 = this.normalizeOptDateSegment(os1);
                    let osDate2 = this.normalizeOptDateSegment(os2);

                    let os3 = row[this.tableHeadersForDB[2]];
                    let osPrice = row[this.tableHeadersForDB[3]];
                    let osQty = row[this.tableHeadersForDB[4]];
                    let sellStatus = row[this.tableHeadersForDB[6]];           //사용여부 = 판매여부
                    let osUse = "Y";
                    await this.$api("/api/ins_product_opt_sel_d", { param: [
                      osCode, osYear, os1, os2, os3, osPrice, osQty, sellStatus, osUse, this.user.handlerId, osDate1, osDate2
                    ] });
                  }
                }
                // 선택하면 선택된 것만 업로드
                else 
                {
                  for(const index of this.selectedRows) {
                    let row = this.tableDataForDB[index];
                    let osYear = row.appliedYear || this.osYear;   // (수정) 엑셀 '적용연도' 우선, 공란이면 기본연도

                    let os1 = row[this.tableHeadersForDB[0]];
                    let os2 = row[this.tableHeadersForDB[1]];

                    // (수정) "8월"/"08월"처럼 0패딩 유무가 작업자마다 달라서 생기던 자릿수 오류 수정
                    let osDate1 = this.normalizeOptDateSegment(os1);
                    let osDate2 = this.normalizeOptDateSegment(os2);

                    let os3 = row[this.tableHeadersForDB[2]];
                    let osPrice = row[this.tableHeadersForDB[3]];
                    let osQty = row[this.tableHeadersForDB[4]];
                    let sellStatus = row[this.tableHeadersForDB[6]];           //사용여부 = 판매여부
                    let osUse = "Y";

                    await this.$api("/api/ins_product_opt_sel_d", {param: [
                      osCode, osYear, os1, os2, os3, osPrice, osQty, sellStatus, osUse, this.user.handlerId, osDate1, osDate2
                    ]});
                  }
                }
              }
              //날짜형이 아닌 경우, 그대로 저장
              else 
              {
                // 업로드할 옵션을 선택하지 않으면 전체업로드
                if(this.selectedRows.length === 0) 
                {
                  for(const row of this.tableDataForDB) {
                    let os1 = row[this.tableHeadersForDB[0]];
                    let os2 = row[this.tableHeadersForDB[1]];
                    let os3 = row[this.tableHeadersForDB[2]];
                    let osPrice = row[this.tableHeadersForDB[3]];
                    let osQty = row[this.tableHeadersForDB[4]];
                    let sellStatus = row[this.tableHeadersForDB[6]];           //사용여부 = 판매여부
                    let osUse = "Y";

                    await this.$api("/api/ins_product_opt_sel_d", {param: [
                      osCode, this.osYear, os1, os2, os3, osPrice, osQty, sellStatus, osUse, this.user.handlerId, null, null
                    ]});
                  }
                }
                // 선택하면 선택된 것만 업로드
                else 
                {
                  for(const index of this.selectedRows) {
                    let row = this.tableDataForDB[index];

                    let os1 = row[this.tableHeadersForDB[0]];
                    let os2 = row[this.tableHeadersForDB[1]];
                    let os3 = row[this.tableHeadersForDB[2]];
                    let osPrice = row[this.tableHeadersForDB[3]];
                    let osQty = row[this.tableHeadersForDB[4]];
                    let sellStatus = row[this.tableHeadersForDB[6]];           //사용여부 = 판매여부
                    let osUse = "Y";

                    await this.$api("/api/ins_product_opt_sel_d", {param: [
                      osCode, this.osYear, os1, os2, os3, osPrice, osQty, sellStatus, osUse, this.user.handlerId, null, null
                    ]});
                  }
                }
              }
            }
            else 
            {
              await this.$api("/api/insOptPdtInfo_fail", {param: [osCode]}); // 등록실패시, 무효화처리

              this.isSaving = false;
              this.$loading.finish();       //인디케이터 중지
              this.$swal.fire("","상품가격 등록 중 에러가 발생했습니다. 재시도해주세요", "warning")
              return false;
            }
          }

          //직접입력 옵션이 있는 경우
          if(this.showDirOptType_flag === "Y")
          {
            ////변경대응
            if(this.priceAri == "Y")
            {
              let odUseFlag = "N"
              let upd_product_opt_dir_m_stat = await this.$api("/api/upd_product_opt_dir_m_stat", {param: [
                odUseFlag, this.user.handlerId, this.product_opt_dir_info.odCode, this.product_opt_dir_info.prcCode
              ]});
              if(upd_product_opt_dir_m_stat.affectedRows < 0)
              {
                this.$swal.fire("","가격/옵션 수정 중에 문제가 발생하였습니다. 관리자에게 문의해 주세요", "error")
                return false;
              }
              // (수정) "직접형 옵션설정에 변경사항이 없습니다" info 팝업 제거
            }

            if(this.dirOptList.length < 1)
            {
              this.$swal.fire("","직접입력 옵션이 없습니다", "warning")
              return false
            }
            else 
            {
              let odUseFlag = "Y"
              // 직접입력옵션 마스타등록
              let ins_product_opt_dir_m = await this.$api("/api/ins_product_opt_dir_m", {param: [
                this.productId, odCode, odUseFlag, this.user.handlerId, prcCode
              ]});
              if(ins_product_opt_dir_m.affectedRows > 0) 
              {
                ////변경대응
                if(this.priceAri == "Y")
                {
                  let odUseFlag = "N"
                  let upd_product_opt_dir_d_stat = await this.$api("/api/upd_product_opt_dir_d_stat", {param: [
                    odUseFlag, this.user.handlerId, this.product_opt_dir_info.odCode
                  ]});
                  if(upd_product_opt_dir_d_stat.affectedRows < 0)
                  {
                    this.$swal.fire("","가격/옵션 수정 중에 문제가 발생하였습니다. 관리자에게 문의해 주세요", "error")
                    return false;
                  }
                }
                
                // 직접입력 옵션 등록
                let i = 0
                for(let dirOpt of this.dirOptList) 
                {
                  i++;
                  let ins_product_opt_dir_d = await this.$api("/api/ins_product_opt_dir_d", {param: [
                    odCode, i, dirOpt.odName, dirOpt.odUseFlag, this.user.handlerId
                  ]});

                  if(ins_product_opt_dir_d.affectedRows < 0) 
                  {
                    await this.$api("/api/insOptPdtInfo_dir_fail", {param: [odCode]});  // 등록실패시, 무효화처리
                    
                    this.isSaving = false;
                    this.$loading.finish();       //인디케이터 중지
                    
                    this.$swal.fire("","직접형 옵션등록 중에러가 발생했습니다. 재시도해주세요", "warning")
                    return false;
                  }
                }
              }
            }
          }
          else 
          {
            console.log("직접형 옵션이 없어 저장하지 않습니다.")
          }

          //추가상품이 있는 경우
          if(this.showAddPdtType_flag === "Y")
          {
            ////변경대응
            if(this.priceAri == "Y")
            {
              let addUseFlag = "N"
              let upd_product_addpdt_m_stat = await this.$api("/api/upd_product_addpdt_m_stat", {param: [
                addUseFlag, this.user.handlerId, this.product_addpdt_m_info.addCode, this.product_addpdt_m_info.prcCode
              ]});
              if(upd_product_addpdt_m_stat.affectedRows < 0)
              {
                this.$swal.fire("","추가상품 정보수정 중에 문제가 발생하였습니다-CaseIII. 관리자에게 문의해 주세요", "error")
                return false;
              }
            }

            //// 추가상품 마스타등록
            let ins_product_addpdt_m = await this.$api("/api/ins_product_addpdt_m", {param: [
              addCode, addName1, addName2, addName3, addUseFlag, this.user.handlerId, this.add_dType, prcCode, this.nullHeaderCount_add
            ]});

            if(ins_product_addpdt_m.affectedRows > 0) 
            {
              ////변경대응
              if(this.priceAri == "Y")
              {
                let addUse = "N"
                let upd_product_addpdt_d_stat = await this.$api("/api/upd_product_addpdt_d_stat", {param: [
                  addUse, this.user.handlerId, this.product_addpdt_m_info.addCode
                ]});
                if(upd_product_addpdt_d_stat.affectedRows < 0)
                {
                  this.$swal.fire("","추가상품 정보수정 중에 문제가 발생하였습니다-CaseIV. 관리자에게 문의해 주세요", "error")
                  return false;
                }
                // (수정) "추가상품 설정에 변경사항이 없습니다" info 팝업 제거
              }

              // 날짜형 옵션인 경우 (구조상 발생하지는 않음)
              if(this.add_dType === "Y")
              {
                // 업로드할 추가상품을 선택하지 않으면 전체업로드
                // (수정) forEach → for...of+await : insert 완료를 보장
                if(this.selectedRows_add.length === 0) 
                {
                  for(const row of this.tableDataForDB_add) {
                    let firstTwo_idx0 = (row[this.tableHeadersForDB_add[0]]).slice(0, 2);
                    let add1_tmp = firstTwo_idx0.match(/\d+/)?.[0];
                    let firstTwo_idx1 = (row[this.tableHeadersForDB_add[1]]).slice(0, 2);
                    let add2_tmp = firstTwo_idx1.match(/\d+/)?.[0];

                    let add1 = row[this.tableHeadersForDB_add[0]];
                    let add2 = row[this.tableHeadersForDB_add[1]];

                    let addDate1 = Number(add1_tmp) >= 10 ? add1_tmp : "0" + add1_tmp;
                    let addDate2 = Number(add2_tmp) >= 10 ? add2_tmp : "0" + add2_tmp;

                    let add3 = row[this.tableHeadersForDB_add[2]];
                    let addPrice = row[this.tableHeadersForDB_add[3]];
                    let addQty = row[this.tableHeadersForDB_add[4]];
                    let addStatus = row[this.tableHeadersForDB_add[5]];           // (2026-07-10 재수정) add는 사용여부가 index5 - 옵션(opt)과 반대 순서 (실제 엑셀 확인됨, 재로드경로도 이제 동일 순서로 통일)
                    let addUse = "Y";

                    await this.$api("/api/ins_product_addpdt_d", { param: [
                      addCode, this.addYear, add1, add2, add3, addPrice, addQty, addStatus, addUse, this.user.handlerId, addDate1, addDate2
                    ] });
                  }
                }
                // 선택하면 선택된 것만 업로드
                else 
                {
                  for(const idx of this.selectedRows_add) {
                    let row = this.tableDataForDB_add[idx];

                    let firstTwo_idx0 = (row[this.tableHeadersForDB_add[0]]).slice(0, 2);
                    let add1_tmp = firstTwo_idx0.match(/\d+/)?.[0];
                    let firstTwo_idx1 = (row[this.tableHeadersForDB_add[1]]).slice(0, 2);
                    let add2_tmp = firstTwo_idx1.match(/\d+/)?.[0];

                    let add1 = row[this.tableHeadersForDB_add[0]];
                    let add2 = row[this.tableHeadersForDB_add[1]];

                    let addDate1 = Number(add1_tmp) >= 10 ? add1_tmp : "0" + add1_tmp;
                    let addDate2 = Number(add2_tmp) >= 10 ? add2_tmp : "0" + add2_tmp;

                    let add3 = row[this.tableHeadersForDB_add[2]];
                    let addPrice = row[this.tableHeadersForDB_add[3]];
                    let addQty = row[this.tableHeadersForDB_add[4]];
                    let addStatus = row[this.tableHeadersForDB_add[5]];           // (2026-07-10 재수정) add는 사용여부가 index5 - 옵션(opt)과 반대 순서 (실제 엑셀 확인됨, 재로드경로도 이제 동일 순서로 통일)
                    let addUse = "Y";

                    await this.$api("/api/ins_product_addpdt_d", { param: [
                      addCode, this.addYear, add1, add2, add3, addPrice, addQty, addStatus, addUse, this.user.handlerId, addDate1, addDate2
                    ]});
                  }
                }
              }
              //날짜형이 아닌 경우, 그대로 저장 - 일반적 케이스
              else 
              {
                // 업로드할 옵션을 선택하지 않으면 전체업로드
                if(this.selectedRows_add.length === 0) 
                {
                  for(const row of this.tableDataForDB_add) {
                    let add1      = row[this.tableHeadersForDB_add[0]];
                    let add2      = row[this.tableHeadersForDB_add[1]];
                    let add3      = row[this.tableHeadersForDB_add[2]];
                    let addPrice  = row[this.tableHeadersForDB_add[3]];
                    let addQty    = row[this.tableHeadersForDB_add[4]];
                    let addStatus = row[this.tableHeadersForDB_add[5]];           // (2026-07-10 재수정) add는 사용여부가 index5 - 옵션(opt)과 반대 순서 (실제 엑셀 확인됨, 재로드경로도 이제 동일 순서로 통일)
                    let addUse    = "Y";

                    await this.$api("/api/ins_product_addpdt_d", {param: [
                      addCode, this.addYear, add1, add2, add3, addPrice, addQty, addStatus, addUse, this.user.handlerId, null, null
                    ]});
                  }
                }
                // 선택하면 선택된 것만 업로드
                else 
                {
                  for(const idx of this.selectedRows_add) {
                    let row = this.tableDataForDB_add[idx];

                    let add1 = row[this.tableHeadersForDB_add[0]];
                    let add2 = row[this.tableHeadersForDB_add[1]];
                    let add3 = row[this.tableHeadersForDB_add[2]];
                    let addPrice = row[this.tableHeadersForDB_add[3]];
                    let addQty = row[this.tableHeadersForDB_add[4]];
                    let addStatus = row[this.tableHeadersForDB_add[5]];           // (2026-07-10 재수정) add는 사용여부가 index5 - 옵션(opt)과 반대 순서 (실제 엑셀 확인됨, 재로드경로도 이제 동일 순서로 통일)
                    let addUse = "Y";

                    await this.$api("/api/ins_product_addpdt_d", {param: [
                      addCode, this.addYear, add1, add2, add3, addPrice, addQty, addStatus, addUse, this.user.handlerId, null, null
                    ]});
                  }
                }
              }
            }
            else 
            {
              await this.$api("/api/insAddPdtInfo_fail", {param: [addCode]}); // 등록실패시, 무효화처리

              this.isSaving = false;
              this.$loading.finish();       //인디케이터 중지
              this.$swal.fire("","추가상품 등록 중 에러가 발생했습니다. 재시도해주세요", "warning")
              return false;
            }
          }          
        }
        this.isSaving = false;
        this.$loading.finish();       //인디케이터 중지
        
        this.$swal.fire("","상품가격이 등록되었습니다.", "success").then(() => {
          location.reload(true)
        })
    },
  }
}
</script>

<style scoped>
  .tb_pdtPrice tr, th, td {
    border: 1px solid;
  }

  #priceSet .tb_pdtPrice td {
    font-size: 0.9rem;
  }
  
  .lb_title {
    font-weight: bold;
    font-size: 1.1rem;
  }

  table th {
    background-color: #b6cfe86a;
    text-align: between;
  }

  /**************************************
    # 선택형 옵션가격표 테이블설정
  **************************************/
  .table-scroll-box {
    max-height: 450px;
    overflow-y: auto;
    border: 1px solid #ced3d9;
    background: #fff;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  }

  /* thead 고정 */
  .table-scroll-box thead th {
    position: sticky;
    top: 0;
    /* background: #fff; */
    background-color: rgba(156, 159, 160, 0.305);
    z-index: 1;
  }

  /**************************************
    # 세이빙 인디케이터
  **************************************/
  .saving-indicator {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: rgba(255,255,255,0.95);
  border-radius: 10px;
  padding: 2rem 2.5rem;
  box-shadow: 0 2px 16px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  font-weight: bold;
  color: #007bff;
}
.spinner {
  width: 28px;
  height: 28px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  margin-right: 1rem;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}


</style>